import { render, staticRenderFns } from "./crisis-blurb.vue?vue&type=template&id=63fad314&scoped=true&"
import script from "./crisis-blurb.vue?vue&type=script&lang=js&"
export * from "./crisis-blurb.vue?vue&type=script&lang=js&"
import style0 from "./crisis-blurb.vue?vue&type=style&index=0&id=63fad314&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63fad314",
  null
  
)

export default component.exports